import * as React from "react";
import TextField from "@material-ui/core/TextField";
import clsx from "clsx";
import { makeStyles, createStyles, withStyles } from "@material-ui/core/styles";
import ApiAutoComplete from "../../components/_Layout/ApiAutoComplete/ApiAutoComplete";
import { useSelector } from "react-redux";
import { FilterParams } from "../../interfaces/common/FilterParams";
import { ApiAutoCompleteConfigItem } from "../../interfaces/ApiAutoCompleteConfigItem";


const config: ApiAutoCompleteConfigItem = {
    acId: "paymentPlans",
    cacheTime: 5,
    route: "/FinancialAid/PaymentPlan/GetPaymentPlans",
    requestType: "GET",
    body: null,
    hasUrlParams: true,
    useCache: false,
    storeInCache: true,
    isCampusSpecific: true,
    isUserSpecific: false,
    loadOnRender: true,
    defaultSelectedFirstItem: false,
    optionsMappedFx: (data: Array<any>) => {
        return data;
    },
};

const ThemeTextField = withStyles((theme: any) =>
    createStyles({
        root: {
            "& label.Mui-focused": {
                color: theme.palette.primary.white,
            },
        },
    })
)(TextField);

const useStyles = makeStyles((theme: any) =>
    createStyles({
        root: {},
        divWidth: {
            width: "95%",
        },
    })
);

const PaymentPlanAutoComplete = (
    props: FilterParams & { stuEnrollId?: string }
) => {
    const classes = useStyles({});
    const selectedEnrollment = useSelector(
        (state: any) => state.student.selectedEnrollment
    );

    let stuEnrollId = "";
    if (selectedEnrollment) {
        stuEnrollId = selectedEnrollment.stuEnrollId;
    }

    const inputRef: any = React.useRef(null);

    const filterHandle = props.filterHandle;

    const scheduleOnChange = (e: any) => {
        if (filterHandle) {
            filterHandle(e);
        }
    };

    return (
        <div className={clsx(classes.divWidth)}>
            <ApiAutoComplete
                disabled={props.disabled}
                config={config}
                loading={selectedEnrollment ? false : true}
                reqParams={{
                    enrollmentId: stuEnrollId,
                }}
                classes={{
                    option: "text-black",
                }}
                label={props.label}
                onChange={(e: any) => {
                    scheduleOnChange(e);
                }}
                multiple={props.multiple ? props.multiple : false}
                valueFilter={props.valueFilter ? props.valueFilter : undefined}
                inputRef={props.inputRef ? props.inputRef : inputRef}
                error={props.error}
                helperText={props.helperText}
                inputName={props.name}
            ></ApiAutoComplete>
        </div>
    );
};
export default PaymentPlanAutoComplete;
